import React from 'react';
import { Input, Radio, Button, Drawer } from 'antd';
import './Profile.css';
import { CaretDownOutlined } from '@ant-design/icons';
import { getApiCallable, showNotif } from "../../firebaseModules/apiclient";
import cx from 'classnames';
import { Spin } from 'antd';
import { updateUserDetails, updateQuestionAnswers } from '../../reduxModules/userReducer/userActions';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import * as firebase from "firebase/app";

class Profile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: {}
    }
  }
  componentDidMount = () => {
    this.fetchUserDetails();
    if (this.props.profileWelcomeMessage) {
      setTimeout(() => {
        this.setState({
          message: this.props.profileWelcomeMessage
        });
      }, 2000)
    }
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.message !== prevState.message && !!this.state.message) {
      setTimeout(() => {
        this.setState({
          message: null
        });
        this.props.updateUserDetails({
          profileWelcomeMessage: null
        });
      }, 3000);
    }
  }
  fetchUserDetails = async (boolForceFetch = false, boolRedirectToHome = false) => {
    let userDetails = this.props.userDetails;
    let user = this.props.user;
    let assessmentStatus = this.props.assessmentStatus;
    let profileQuestions = this.props.profileQuestions;
    let homescreenData = this.props.homescreenData;
    if (!userDetails || boolForceFetch) {
      const getUserDetailsCallable = getApiCallable("getUserDetails");
      const res = await getUserDetailsCallable();
      userDetails = res.data.userDetails;
      assessmentStatus = res.data.assessmentStatus;
      profileQuestions = res.data.profileQuestions;
      homescreenData = res.data.homescreenData;
      user = res.data.user;
    }
    if (userDetails) {
      this.props.updateUserDetails({
        user: user,
        userDetails,
        assessmentStatus,
        profileQuestions,
        homescreenData
      });
    }
    if (boolRedirectToHome) {
      this.props.history.replace('/');
    }
    this.setState({
      loading: false
    });
  }
  hideOptions = () => {
    this.setState({
      showOptions: {}
    });
  }
  onSave = async () => {
    const questions = this.props.profileQuestions;
    const allGood = this.validateAnswers(questions);
    if (allGood) {
      try {
        this.setState({
          loading: true
        });
        const saveUserDetailsCallable = getApiCallable("saveUserDetails");
        const res = await saveUserDetailsCallable({ questions });
        this.setState({
          message: 'Details saved'
        });
        const boolRedirectToHome = res.data.action === 'created';
        this.fetchUserDetails(true, boolRedirectToHome);
      } catch (e) {
        this.setState({
          loading: false
        });
        showNotif(e);
      }
    }
  }
  validateAnswers = (_questions) => {
    let allGood = true;
    const questions = _questions.map(ques => {
      switch (ques.type) {
        case 'input':
        case 'textarea':
          if (!ques.value) {
            allGood = false;
            return {
              ...ques,
              showError: true
            };
          }
          return ques;
        default:
          if (!ques.answer_id) {
            allGood = false;
            return {
              ...ques,
              showError: true
            };
          }
          return ques;
      }
    });
    if (!allGood) {
      this.props.updateQuestionAnswers(questions);
    }
    return allGood;
  }
  onQuestionAnswered = (question, index, event) => {
    this.setState({
      showOptions: {
        [question.question_id]: false
      }
    });
    let questions = this.props.profileQuestions;
    switch (question.type) {
      case 'input':
      case 'textarea':
        questions = questions.map((ques, quesIndex) => {
          if (index === quesIndex) {
            return {
              ...ques,
              value: event.target.value,
              showError: !!event.target.value ? false : ques.showError
            };
          }
          return ques;
        });
        break;
      case 'select':
        questions = questions.map((ques, quesIndex) => {
          if (index === quesIndex) {
            const answerId = event.target.value;
            const answer = ques.answers.find(a => a.answer_id === answerId);
            return {
              ...ques,
              answer_id: answerId,
              showError: !!answerId ? false : ques.showError,
              onSelectErrorMessage: answer.on_select_error_message
            };
          }
          return ques;
        });
        break;
      case 'dropdown':
        questions = questions.map((ques, quesIndex) => {
          if (index === quesIndex) {
            const answerId = event.answer_id;
            const answer = ques.answers.find(a => a.answer_id === answerId);
            return {
              ...ques,
              value: event.text,
              answer_id: answerId,
              showError: !!answerId ? false : ques.showError,
              onSelectErrorMessage: answer.on_select_error_message
            };
          }
          return ques;
        });
        break;
      default:
    }
    this.props.updateQuestionAnswers(questions);
  }
  showOptions = (question) => {
    if (!question.disabled) {
      this.setState({
        showOptions: {
          ...this.state.showOptions,
          [question.question_id]: true
        }
      });
    }
  }
  render() {
    const radioStyle = {
      width: '50%',
      float: 'left',
      margin: 0,
      height: '30px',
      lineHeight: '30px',
    };
    const bodyStyle = {
      padding: 0
    }
    const currentUser = firebase.auth().currentUser;
    const userInfo = {
      name: currentUser ? currentUser.displayName : '',
      photoURL: currentUser ? currentUser.photoURL : '',
      email: currentUser ? currentUser.email : '',
    };
    return (
      <div className="wrapper">
        <p className={cx('message', this.state.message ? 'show' : '')}>
          {this.state.message}
        </p>
        {
          this.state.loading &&
          <div className="overlay">
            <Spin />
          </div>
        }
        <div className="profileContainer">
          <div className="scroller">
            <div className="profileInfo">
              {
                userInfo &&
                userInfo.photoURL &&
                <img className="profilePic" src={userInfo.photoURL} alt=""/>
              }
              {
                userInfo &&
                userInfo.name &&
                <p className="name">{userInfo.name}</p>
              }
            </div>
            {
              this.props.profileQuestions &&
              this.props.profileQuestions.map((question, index) => {
                switch (question.type) {
                  case 'input':
                    return (
                      <div className="fieldContainer" key={index}>
                        <label className="ucLabel" htmlFor={question.question_id}>{question.text}</label>
                        <Input
                          size="large"
                          id={question.question_id}
                          placeholder={question.placeholder}
                          className="ucInput"
                          onChange={this.onQuestionAnswered.bind({}, question, index)}
                          value={question.value}
                          disabled={question.disabled}
                        />
                        {
                          question.error_message_if_missing && question.showError &&
                          <p className="errorMessage">{question.error_message_if_missing}</p>
                        }
                      </div>
                    );
                  case 'dropdown':
                    return (
                      <div key={index}>
                        <div
                          className="fieldContainer"
                          tabIndex="0"
                          key={index}
                          onFocus={this.showOptions.bind({}, question)}
                          onClick={this.showOptions.bind({}, question)}>
                          <label className="ucLabel" htmlFor={question.question_id}>{question.text}</label>
                          <Input
                            size="large"
                            id={question.question_id}
                            placeholder={question.placeholder}
                            disabled
                            className="ucInput"
                            value={question.value}
                            tabIndex="0"
                            style={{
                              backgroundColor: question.disabled ? '#f5f5f5' : '#ffffff'
                            }}
                          />
                          {
                            question.error_message_if_missing && question.showError &&
                            <p className="errorMessage">{question.error_message_if_missing}</p>
                          }
                          {
                            question.onSelectErrorMessage &&
                            <p className="errorMessage">{question.onSelectErrorMessage}</p>
                          }
                          <CaretDownOutlined className="carretDown" />
                        </div>
                        <Drawer
                          placement="right"
                          onClose={this.hideOptions}
                          visible={this.state.showOptions[question.question_id]}
                          getContainer={false}
                          style={{ position: 'absolute' }}
                          width="100%"
                          closable
                          bodyStyle={bodyStyle}>
                          {
                            question.answers && question.answers.length > 0 &&
                            <div className="optionsContainer">
                              {
                                question.answers.map((option, _index) => (
                                  <p
                                    key={_index}
                                    style={{
                                      backgroundColor: question.value === option.text ? '#f0f0f0' : '#ffffff'
                                    }}
                                    onClick={this.onQuestionAnswered.bind({}, question, index, option)}
                                  >
                                    {option.text}
                                  </p>
                                ))
                              }
                            </div>
                          }
                        </Drawer>
                      </div>
                    )
                  case 'select':
                    return  (
                      <div className="fieldContainer" key={index}>
                        <label className="ucLabel" htmlFor={question.question_id}>{question.text}</label>
                        <Radio.Group
                          value={question.answer_id}
                          disabled={question.disabled}
                          id={question.question_id}
                          onChange={this.onQuestionAnswered.bind({}, question, index)}
                          style={{
                            backgroundColor: question.disabled ? '#f5f5f5' : '#ffffff'
                          }}
                        >
                          {
                            question.answers &&
                            question.answers.map((answer, answerIndex) => (
                              <Radio
                                className="ucRadio"
                                key={answerIndex}
                                style={radioStyle}
                                value={answer.answer_id}
                              >{answer.text}</Radio>
                            ))
                          }
                        </Radio.Group>
                        {
                          question.error_message_if_missing && question.showError &&
                          <p className="errorMessage">{question.error_message_if_missing}</p>
                        }
                        {
                          question.onSelectErrorMessage &&
                          <p className="errorMessage">{question.onSelectErrorMessage}</p>
                        }
                      </div>
                    );
                  case 'textarea':
                    return (
                      <div className="fieldContainer" key={index}>
                        <label className="ucLabel" htmlFor={question.question_id}>{question.text}</label>
                        <Input.TextArea
                          row="10"
                          id={question.question_id}
                          style={{ height: 80, resize: 'none' }}
                          onChange={this.onQuestionAnswered.bind({}, question, index)}
                          size="large"
                          placeholder={question.placeholder}
                          className="ucInput"
                          value={question.value}
                          disabled={question.disabled}
                        />
                        {
                          question.error_message_if_missing && question.showError &&
                          <p className="errorMessage">{question.error_message_if_missing}</p>
                        }
                      </div>
                    );
                  default:
                    return <span key={index} />;
                }
              })
            }
            {
              this.props.profileQuestions &&
              <Button
                className="ucButton submit"
                size="large"
                onClick={this.onSave}
              >
                Save
              </Button>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    userDetails: state.userReducer.userDetails,
    profileQuestions: state.userReducer.profileQuestions,
    profileWelcomeMessage: state.userReducer.profileWelcomeMessage,
    user: state.authReducer.user,
    assessmentStatus: state.userReducer.assessmentStatus,
    homescreenData: state.userReducer.homescreenData,
  }),
  (dispatch) => bindActionCreators({ updateUserDetails, updateQuestionAnswers }, dispatch)
)(withRouter(Profile));